export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1612544409025-e1f6a56c1152?crop=entropy&cs=srgb&fm=jpg&q=85",
  cameraRig: "https://images.unsplash.com/photo-1518930259200-3e5b29f42096?crop=entropy&cs=srgb&fm=jpg&q=85",
  soundstage: "https://images.unsplash.com/photo-1632187989763-c9c620420b4d?crop=entropy&cs=srgb&fm=jpg&q=85",
  tabletopPerfume: "https://images.pexels.com/photos/11295238/pexels-photo-11295238.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  tabletopLuxury: "https://images.pexels.com/photos/11295243/pexels-photo-11295243.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  studioLighting: "https://images.unsplash.com/photo-1471341971476-ae15ff5dd4ea?crop=entropy&cs=srgb&fm=jpg&q=85",
  digital: [
    "https://images.pexels.com/photos/13807652/pexels-photo-13807652.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    "https://images.pexels.com/photos/15148384/pexels-photo-15148384.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    "https://images.unsplash.com/photo-1556284256-77220ef9f660?crop=entropy&cs=srgb&fm=jpg&q=85",
  ],
  corporate: [
    "https://images.pexels.com/photos/36736681/pexels-photo-36736681.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    "https://images.pexels.com/photos/5518638/pexels-photo-5518638.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?crop=entropy&cs=srgb&fm=jpg&q=85",
  ],
  ai: [
    "https://images.unsplash.com/photo-1674027444485-cec3da58eef4?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1644088379091-d574269d422f?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.pexels.com/photos/14314636/pexels-photo-14314636.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  ],
  editing: [
    "https://images.pexels.com/photos/39694504/pexels-photo-39694504.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    "https://images.pexels.com/photos/8100063/pexels-photo-8100063.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  ],
  showreel: "https://images.pexels.com/photos/23384428/pexels-photo-23384428.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  ctaBg: "https://images.pexels.com/photos/4722576/pexels-photo-4722576.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const SHOWREEL_VIDEO_URL = "https://customer-assets-cm19k8pv.emergentagent.net/job_rvfilm-digital/artifacts/10a83dca82cdb4dc_remote%20streaming.mp4";

export const BRAND_LOGO_URL = "https://customer-assets-cm19k8pv.emergentagent.net/job_rvfilm-digital/artifacts/19b5a0c25cbdb090_Senza%20titolo.webp";

export const ADV_SPOTS = [
  {
    title: "Bentley Continental",
    meta: "Spot · 2017",
    url: "https://customer-assets-cm19k8pv.emergentagent.net/job_rvfilm-digital/artifacts/d875d270bd14244a_Bentley%20Continental%202017.mp4",
  },
  {
    title: "Promopharma Nutritask",
    meta: "Spot TV",
    url: "https://customer-assets-cm19k8pv.emergentagent.net/job_rvfilm-digital/artifacts/e0d34c31daca34ae_Promopharma%20Nutritask.mp4",
  },
  {
    title: "Promopharma Dimagra 15″",
    meta: "Spot TV · 15″",
    url: "https://customer-assets-cm19k8pv.emergentagent.net/job_rvfilm-digital/artifacts/8ed5f20748227d1d_promopharma_dimagra_15_%20%281080p%29.mp4",
  },
  {
    title: "Remote Streaming",
    meta: "Produzione",
    url: "https://customer-assets-cm19k8pv.emergentagent.net/job_rvfilm-digital/artifacts/daf461bb0edaec79_remote%20streaming.mp4",
  },
];

export const DIGITAL_VIDEOS = [
  {
    title: "Montaia — Quality Style",
    meta: "Commercial · 30″",
    url: "https://customer-assets-cm19k8pv.emergentagent.net/job_rvfilm-digital/artifacts/57b2b5c5dc243822_montaia__...quality_style__-_commercial_30_%20%28720p%29.mp4",
  },
  {
    title: "Castiflex",
    meta: "Commercial · 30″",
    youtube: "iDsvAWV_hFU",
  },
  {
    title: "Hornimans Tea",
    meta: "Spot · dir. Eduardo Vieitez",
    url: "https://customer-assets-cm19k8pv.emergentagent.net/job_rvfilm-digital/artifacts/06599c6b053c255c_Hornimans%20Tea%20-%20dir.%20Eduardo%20Vieitez%281%29.mp4",
  },
];

export const AI_VIDEOS = [
  {
    title: "Mountain Coffee",
    meta: "Spot · AI",
    url: "https://customer-assets-cm19k8pv.emergentagent.net/job_rvfilm-digital/artifacts/7be1ffb183543bdd_Mountain%20Coffee%20AI%281%29.mp4",
  },
  {
    title: "Best Burger",
    meta: "Spot · AI",
    youtube: "0a7nTK-HpII",
  },
];

export const CORPORATE_VIDEOS = [
  {
    title: "Celag",
    meta: "Video Corporate",
    url: "https://customer-assets-cm19k8pv.emergentagent.net/job_rvfilm-digital/artifacts/45b82835f2836e8a_celag_video_corporate%20%281080p%29.mp4",
  },
  {
    title: "CMS",
    meta: "Video Corporate",
    url: "https://customer-assets-cm19k8pv.emergentagent.net/job_rvfilm-digital/artifacts/eba1d54d245fbdc2_cms_corporate%20%281080p%29%281%29%281%29.mp4",
  },
  {
    title: "Achilli Gold — Tutorial",
    meta: "Video Corporate",
    url: "https://customer-assets-cm19k8pv.emergentagent.net/job_rvfilm-digital/artifacts/b712c859720c2322_achilli_gold_tutorial_v1%20%281080p%29.mp4",
  },
  {
    title: "Vicivision — Arcoprofil Interview",
    meta: "Video Corporate",
    url: "https://customer-assets-cm19k8pv.emergentagent.net/job_rvfilm-digital/artifacts/d57f405e6384dfdd_VICIVISION-Arcoprofil%20Interview%282%29.mp4",
  },
];

export const VIDEOCLIP_VIDEOS = [
  {
    title: "Marco Ballerini — Fino all'alba",
    meta: "Videoclip · Black Out",
    youtube: "0eH78cdPP6k",
  },
  {
    title: "Michela Belletti — I Was There",
    meta: "Videoclip",
    youtube: "jTaMgemxGWw",
  },
  {
    title: "Samuel — Vedrai",
    meta: "Videoclip · Sanremo 2017",
    youtube: "L80A_nr9MFk",
    external: true,
  },
  {
    title: "Chiara Fabbri — Il Sole Dentro Me",
    meta: "Videoclip",
    youtube: "KnS1AkDCvxk",
  },
];

export const PARTNERS = [
  "ACHILLI",
  "ACQUA SAN BENEDETTO",
  "CELAG",
  "CMS",
  "COSER",
  "DISCOVERY",
  "EMILIA ROMAGNA FILM COMMISSION",
  "MASTERWOOD",
  "MELEGATTI",
  "PROMOPHARMA",
  "SONY",
  "VICIVISION",
];

export const copy = {
  it: {
    seo: {
      homeTitle: "RV FILM — Realizziamo video che fanno vendere",
      homeDesc: "RV FILM: casa di produzione video a Santarcangelo di Romagna (Rimini). Spot ADV, digital, corporate, video AI e videoclip in Emilia-Romagna, Italia e worldwide.",
      contactTitle: "RV FILM — Contatti e preventivi",
    },
    nav: {
      home: "Home",
      adv: "ADV",
      digital: "Digital",
      corporate: "Corporate",
      ai: "AI",
      videoclip: "Video Clip",
      contact: "Contatti",
      cta: "Prenota consulenza",
    },
    hero: {
      kicker: "RV FILM · Divisione video di Radiovilles",
      lines: [
        { text: "REALIZZIAMO", serif: false },
        { text: "VIDEO", serif: true },
        { text: "CHE FANNO VENDERE", serif: false },
      ],
      sub: "Spot pubblicitari, contenuti digitali, video corporate e produzione AI per aziende industriali che esigono risultati misurabili.",
      ctaShowreel: "Guarda lo showreel",
      ctaConsult: "Analisi gratuita",
      location: "Santarcangelo di Romagna · Operiamo worldwide",
    },
    marquee: ["SPOT TV", "TABLETOP", "DIGITAL", "SOCIAL", "CORPORATE", "AI VIDEO", "PROMO", "EVENTI"],
    stats: {
      kicker: "Risultati",
      titleA: "Non facciamo solo bei video.",
      titleB: "Costruiamo risultati.",
      items: [
        { value: "+68%", label: "Vendite dirette da campagna video" },
        { value: "4M+", label: "Prodotti venduti con spot TV" },
        { value: "+115%", label: "Contatti B2B qualificati" },
        { value: "11", label: "Anni di produzione industriale" },
      ],
    },
    services: {
      kicker: "Cosa produciamo",
      title: "Quattro divisioni. Un unico standard cinematografico.",
      discover: "Scopri la divisione",
      adv: {
        name: "ADV",
        tagline: "Spot & Tabletop",
        desc: "Spot pubblicitari TV e tabletop product film ad altissima risoluzione, per campagne ad alto impatto.",
      },
      digital: {
        name: "DIGITAL",
        tagline: "Social & Web",
        desc: "Contenuti verticali e campagne digital pensate per fermare lo scroll e convertire.",
      },
      corporate: {
        name: "CORPORATE",
        tagline: "Industriale & B2B",
        desc: "Storytelling di stabilimento e video aziendali che danno volto e voce al tuo brand.",
      },
      ai: {
        name: "AI",
        tagline: "Video generativo",
        desc: "Produzione video potenziata dall'intelligenza artificiale: velocità, scala, visioni impossibili.",
      },
    },
    process: {
      kicker: "Il metodo",
      title: "Dalla strategia al master finale, tutto in-house.",
      steps: [
        { n: "01", title: "Strategia", desc: "Analisi del mercato, del target e dell'obiettivo di vendita. Ogni video nasce da un numero da raggiungere." },
        { n: "02", title: "Produzione", desc: "Regia, direzione della fotografia e set professionale. Cinema camera, ottiche e lighting design proprietari." },
        { n: "03", title: "Post-produzione", desc: "Montaggio, color grading, sound design e motion graphic nelle nostre suite di Santarcangelo." },
        { n: "04", title: "Distribuzione", desc: "Adattiamo ogni master ai canali: TV, social, fiere, web. Misuriamo i risultati, insieme." },
      ],
    },
    why: {
      kicker: "Perché sceglierci",
      title: "Un solo partner per tutta la tua comunicazione video.",
      desc: "In Radiovilles ogni servizio è progettato per integrarsi con gli altri: niente più fornitori da coordinare, un unico interlocutore in linea con la tua visione e i tuoi obiettivi.",
      points: [
        "Dalla strategia al master finale, tutto in-house",
        "11 anni di produzione per brand industriali",
        "Iscritti alla guida alla produzione di Emilia-Romagna Film Commission",
      ],
    },
    partners: {
      kicker: "Partners",
      title: "Hanno scelto la nostra regia.",
    },
    cta: {
      titleA: "Pronto a fare il",
      titleB: "salto di qualità?",
      desc: "Prenota un'analisi gratuita della tua comunicazione e scopri come il video può far crescere il tuo business.",
      button: "Prenota ora",
    },
    servicePages: {
      backHome: "Torna alla home",
      deliverablesTitle: "Cosa realizziamo",
      spotsTitle: "Gli spot",
      galleryTitle: "Dal set",
      ctaTitle: "Parliamone.",
      ctaDesc: "Raccontaci il tuo progetto: ti rispondiamo entro 24 ore lavorative con una proposta concreta.",
      ctaButton: "Richiedi un preventivo",
      adv: {
        kicker: "01 · Divisione ADV",
        titleA: "Spot che restano",
        titleB: "impressi.",
        desc: "Dalla concezione creativa alla consegna del master finale: spot televisivi, tabletop product film ad altissima risoluzione e branded content che trasformano il prodotto in protagonista.",
        heroImg: "soundstage",
        deliverables: [
          { title: "Spot TV 30″ / 15″", desc: "Soggetti pubblicitari per emittenti nazionali e locali, con pianificazione del formato per ogni rete." },
          { title: "Tabletop product film", desc: "Riprese macro ad altissima risoluzione: food, beverage, cosmetica e prodotto industriale in luce perfetta." },
          { title: "Branded content", desc: "Storie di marca che intrattengono prima di vendere, per piattaforme digitali e TV connesse." },
          { title: "Campagne multisoggetto", desc: "Sistemi di contenuti coordinati: un'idea creativa, declinata su ogni canale e formato." },
        ],
        gallery: [
          {
            video: "https://customer-assets-cm19k8pv.emergentagent.net/job_rvfilm-digital/artifacts/25371c4f1252805a_samsung_galaxy.__mission_to_mars_teaser%20%28720p%29.mp4",
            title: "Samsung Galaxy — Mission to Mars",
          },
          "cameraRig",
        ],
        spots: ADV_SPOTS,
        directorsTitle: "I registi con cui collaboriamo",
        directors: [
          { name: "Eduardo Vieitez", note: "Spain" },
          { name: "Federico Cambria" },
          { name: "Kit Lynch Robinson" },
          { name: "Mario Tagliabue" },
          { name: "Massimo Zambiasi" },
        ],
      },
      digital: {
        kicker: "02 · Divisione Digital",
        titleA: "Contenuti che fermano",
        titleB: "lo scroll.",
        desc: "Video verticali, campagne performance e micro-contenuti nati per le piattaforme: ritmo, hook immediati e call to action misurabili.",
        heroImg: "digital0",
        deliverables: [
          { title: "Social video verticali", desc: "Formati 9:16 per Reels, TikTok e Shorts, pensati per i primi tre secondi." },
          { title: "Campagne performance", desc: "Video ADV per Meta, Google e programmatic, con varianti A/B per ottimizzare la conversione." },
          { title: "Motion graphic", desc: "Animazioni, infografiche animate e titolazione dinamica per spiegare l'inspiegabile." },
          { title: "Content plan mensile", desc: "Produzione continuativa di contenuti: il tuo canale sempre vivo, senza pensieri." },
        ],
        gallery: ["digital1", "digital2", "editing1"],
        spots: DIGITAL_VIDEOS,
        spotsTitle: "I contenuti",
      },
      corporate: {
        kicker: "03 · Divisione Corporate",
        titleA: "La tua azienda,",
        titleB: "in presa diretta.",
        desc: "Video aziendali, reportage industriali e storytelling di stabilimento per raccontare processi, persone e visione a clienti, partner e investitori.",
        heroImg: "corporate0",
        deliverables: [
          { title: "Company profile", desc: "Il film istituzionale della tua impresa: stabilimenti, persone, numeri e visione in pochi minuti." },
          { title: "Reportage industriale", desc: "Documentazione cinematografica di linee produttive, macchinari e processi tecnologici." },
          { title: "Video per fiere", desc: "Contenuti per stand ed eventi che attraggono visitatori e spiegano il prodotto senza bisogno di parole." },
          { title: "Internal & safety", desc: "Formazione, sicurezza e comunicazione interna con la qualità che i tuoi team meritano." },
        ],
        gallery: ["corporate1", "corporate2", "studioLighting"],
        spots: CORPORATE_VIDEOS,
        spotsTitle: "I video corporate",
      },
      ai: {
        kicker: "04 · Divisione AI",
        titleA: "Visioni oltre",
        titleB: "il reale.",
        desc: "Integriamo motori generativi e pipeline neurali nel flusso di produzione: mockup ultra-rapidi, virtual set e spot impossibili da girare con la camera.",
        heroImg: "ai0",
        deliverables: [
          { title: "Spot AI-generativi", desc: "Mondi, ambientazioni e prodotti sintetici con qualità fotorealistica e controllo creativo totale." },
          { title: "Virtual set & avatar", desc: "Presenter digitali e ambienti virtuali per contenuti scalabili in ogni lingua." },
          { title: "Pre-visualizzazione", desc: "Animatic e mockup video in tempi rapidissimi per validare l'idea prima del set." },
          { title: "Workflow ibrido", desc: "Ripresa reale + AI: il meglio dei due mondi, con costi e tempi ottimizzati." },
        ],
        gallery: ["ai1", "ai2", "editing0"],
        spots: AI_VIDEOS,
        spotsTitle: "I video AI",
      },
      videoclip: {
        kicker: "05 · Divisione Video Clip",
        titleA: "Musica che",
        titleB: "si guarda.",
        desc: "Videoclip musicali, live session e visual content per artisti ed etichette: regia cinematografica al servizio del sound.",
        heroImg: "digital2",
        deliverables: [
          { title: "Videoclip musicali", desc: "Dal concept alla post-produzione: il video ufficiale del tuo brano con qualità cinematografica." },
          { title: "Live session", desc: "Riprese multicamera di performance dal vivo, con audio curato e montaggio dinamico." },
          { title: "Lyric & visual video", desc: "Contenuti visuali e lyric video per lanciare singoli e album su ogni piattaforma." },
          { title: "Backstage & documentari", desc: "Raccontiamo la lavorazione e la storia dietro la musica." },
        ],
        gallery: ["editing1", "soundstage", "digital1"],
        spots: VIDEOCLIP_VIDEOS,
        spotsTitle: "I videoclip",
      },
    },
    contact: {
      kicker: "Contatti",
      titleA: "Raccontaci",
      titleB: "il tuo progetto.",
      desc: "Compila il form: ti ricontattiamo entro 24 ore lavorative con una prima valutazione gratuita.",
      name: "Nome e cognome",
      namePh: "Mario Rossi",
      email: "Email",
      emailPh: "mario@azienda.it",
      company: "Azienda",
      companyPh: "Nome dell'azienda",
      service: "Servizio di interesse",
      serviceOptions: ["ADV / Spot TV", "Digital & Social", "Corporate", "AI Video", "Altro"],
      budget: "Budget indicativo",
      budgetOptions: ["< 5.000 €", "5.000 – 15.000 €", "15.000 – 50.000 €", "> 50.000 €"],
      message: "Messaggio",
      messagePh: "Raccontaci obiettivi, tempi e cosa vorresti ottenere dal video…",
      submit: "Invia richiesta",
      sending: "Invio in corso…",
      successTitle: "Richiesta inviata",
      successDesc: "Ti ricontatteremo entro 24 ore lavorative.",
      errorTitle: "Qualcosa è andato storto",
      errorDesc: "Riprova o scrivici direttamente via email.",
      infoTitle: "La sede",
      address: "Via U. Braschi 8, 47822 Santarcangelo di Romagna (RN) · Italia",
      scope: "Produzione video a Rimini e in tutta l'Emilia-Romagna · operiamo su scala nazionale e internazionale",
      emailLabel: "Email",
      reply: "Risposta garantita entro 24h lavorative",
    },
    footer: {
      blurb: "RV FILM è la divisione video production di Radiovilles: spot, contenuti digitali, corporate e AI video per aziende che esigono risultati reali. Studio a Santarcangelo di Romagna (Rimini), attivo in Emilia-Romagna, in tutta Italia e all'estero.",
      nav: "Navigazione",
      contactTitle: "Contatti",
      rights: "© 2026 RV FILM · Radiovilles. Tutti i diritti riservati.",
    },
  },
  en: {
    seo: {
      homeTitle: "RV FILM — We craft videos that sell",
      homeDesc: "RV FILM: video production house in Santarcangelo di Romagna (Rimini). Commercials, digital, corporate, AI video and music videos in Emilia-Romagna, Italy and worldwide.",
      contactTitle: "RV FILM — Contact & quotes",
    },
    nav: {
      home: "Home",
      adv: "ADV",
      digital: "Digital",
      corporate: "Corporate",
      ai: "AI",
      videoclip: "Music Videos",
      contact: "Contact",
      cta: "Book a call",
    },
    hero: {
      kicker: "RV FILM · Radiovilles video division",
      lines: [
        { text: "WE CRAFT", serif: false },
        { text: "VIDEOS", serif: true },
        { text: "THAT SELL", serif: false },
      ],
      sub: "Commercials, digital content, corporate films and AI production for industrial brands that demand measurable returns.",
      ctaShowreel: "Watch the showreel",
      ctaConsult: "Free analysis",
      location: "Santarcangelo di Romagna · Operating worldwide",
    },
    marquee: ["TV SPOTS", "TABLETOP", "DIGITAL", "SOCIAL", "CORPORATE", "AI VIDEO", "PROMO", "EVENTS"],
    stats: {
      kicker: "Results",
      titleA: "We don't just make pretty videos.",
      titleB: "We build results.",
      items: [
        { value: "+68%", label: "Direct sales from video campaigns" },
        { value: "4M+", label: "Products sold through TV spots" },
        { value: "+115%", label: "Qualified B2B leads" },
        { value: "11", label: "Years of industrial production" },
      ],
    },
    services: {
      kicker: "What we produce",
      title: "Four divisions. One cinematic standard.",
      discover: "Explore the division",
      adv: {
        name: "ADV",
        tagline: "Spots & Tabletop",
        desc: "TV commercials and ultra-high-resolution tabletop product films for high-impact campaigns.",
      },
      digital: {
        name: "DIGITAL",
        tagline: "Social & Web",
        desc: "Vertical content and digital campaigns engineered to stop the scroll and convert.",
      },
      corporate: {
        name: "CORPORATE",
        tagline: "Industrial & B2B",
        desc: "Plant storytelling and corporate films that give your brand a face and a voice.",
      },
      ai: {
        name: "AI",
        tagline: "Generative video",
        desc: "AI-powered video production: speed, scale, and visions impossible to shoot.",
      },
    },
    process: {
      kicker: "The method",
      title: "From strategy to final master, all in-house.",
      steps: [
        { n: "01", title: "Strategy", desc: "Market, audience and sales-goal analysis. Every video starts from a number to hit." },
        { n: "02", title: "Production", desc: "Direction, cinematography and a professional set. Cinema cameras, lenses and in-house lighting design." },
        { n: "03", title: "Post-production", desc: "Editing, color grading, sound design and motion graphics in our Santarcangelo suites." },
        { n: "04", title: "Distribution", desc: "We adapt every master to its channel: TV, social, trade fairs, web. And we measure results, together." },
      ],
    },
    why: {
      kicker: "Why choose us",
      title: "One partner for all your video communication.",
      desc: "At Radiovilles every service is designed to integrate with the others: no more vendors to coordinate, a single point of contact aligned with your vision and goals.",
      points: [
        "From strategy to final master, all in-house",
        "11 years of production for industrial brands",
        "Listed in the Emilia-Romagna Film Commission production guide",
      ],
    },
    partners: {
      kicker: "Partners",
      title: "Directed by us.",
    },
    cta: {
      titleA: "Ready to make the",
      titleB: "quality leap?",
      desc: "Book a free analysis of your communication and discover how video can grow your business.",
      button: "Book now",
    },
    servicePages: {
      backHome: "Back to home",
      deliverablesTitle: "What we deliver",
      spotsTitle: "The commercials",
      galleryTitle: "From the set",
      ctaTitle: "Let's talk.",
      ctaDesc: "Tell us about your project: we'll reply within 24 working hours with a concrete proposal.",
      ctaButton: "Request a quote",
      adv: {
        kicker: "01 · ADV Division",
        titleA: "Spots that stay",
        titleB: "imprinted.",
        desc: "From creative concept to final master: TV commercials, ultra-high-resolution tabletop product films and branded content that turn your product into the protagonist.",
        heroImg: "soundstage",
        deliverables: [
          { title: "TV spots 30″ / 15″", desc: "Commercials for national and local broadcasters, formatted for every network." },
          { title: "Tabletop product films", desc: "Ultra-high-resolution macro shoots: food, beverage, cosmetics and industrial products in perfect light." },
          { title: "Branded content", desc: "Brand stories that entertain before they sell, for digital platforms and connected TV." },
          { title: "Multi-subject campaigns", desc: "Coordinated content systems: one creative idea, adapted to every channel and format." },
        ],
        gallery: [
          {
            video: "https://customer-assets-cm19k8pv.emergentagent.net/job_rvfilm-digital/artifacts/25371c4f1252805a_samsung_galaxy.__mission_to_mars_teaser%20%28720p%29.mp4",
            title: "Samsung Galaxy — Mission to Mars",
          },
          "cameraRig",
        ],
        spots: ADV_SPOTS,
        directorsTitle: "Directors we collaborate with",
        directors: [
          { name: "Eduardo Vieitez", note: "Spain" },
          { name: "Federico Cambria" },
          { name: "Kit Lynch Robinson" },
          { name: "Mario Tagliabue" },
          { name: "Massimo Zambiasi" },
        ],
      },
      digital: {
        kicker: "02 · Digital Division",
        titleA: "Content that stops",
        titleB: "the scroll.",
        desc: "Vertical videos, performance campaigns and micro-content born for the platforms: pace, instant hooks and measurable calls to action.",
        heroImg: "digital0",
        deliverables: [
          { title: "Vertical social videos", desc: "9:16 formats for Reels, TikTok and Shorts, designed around the first three seconds." },
          { title: "Performance campaigns", desc: "Video ads for Meta, Google and programmatic, with A/B variants to optimise conversion." },
          { title: "Motion graphics", desc: "Animation, animated infographics and dynamic titling to explain the unexplainable." },
          { title: "Monthly content plan", desc: "Ongoing content production: your channel always alive, without the hassle." },
        ],
        gallery: ["digital1", "digital2", "editing1"],
        spots: DIGITAL_VIDEOS,
        spotsTitle: "The work",
      },
      corporate: {
        kicker: "03 · Corporate Division",
        titleA: "Your company,",
        titleB: "live on film.",
        desc: "Corporate films, industrial reportage and plant storytelling to present processes, people and vision to clients, partners and investors.",
        heroImg: "corporate0",
        deliverables: [
          { title: "Company profile", desc: "Your company's institutional film: plants, people, numbers and vision in a few minutes." },
          { title: "Industrial reportage", desc: "Cinematic documentation of production lines, machinery and technological processes." },
          { title: "Trade-fair videos", desc: "Content for booths and events that attracts visitors and explains the product without words." },
          { title: "Internal & safety", desc: "Training, safety and internal communication with the quality your teams deserve." },
        ],
        gallery: ["corporate1", "corporate2", "studioLighting"],
        spots: CORPORATE_VIDEOS,
        spotsTitle: "Corporate films",
      },
      ai: {
        kicker: "04 · AI Division",
        titleA: "Visions beyond",
        titleB: "the real.",
        desc: "We integrate generative engines and neural pipelines into the production flow: ultra-fast mockups, virtual sets and spots impossible to shoot with a camera.",
        heroImg: "ai0",
        deliverables: [
          { title: "AI-generated spots", desc: "Synthetic worlds, sets and products with photorealistic quality and total creative control." },
          { title: "Virtual sets & avatars", desc: "Digital presenters and virtual environments for content that scales into every language." },
          { title: "Pre-visualisation", desc: "Animatics and video mockups in record time to validate the idea before the shoot." },
          { title: "Hybrid workflow", desc: "Real footage + AI: the best of both worlds, with optimised costs and timelines." },
        ],
        gallery: ["ai1", "ai2", "editing0"],
        spots: AI_VIDEOS,
        spotsTitle: "AI videos",
      },
      videoclip: {
        kicker: "05 · Music Video Division",
        titleA: "Music you can",
        titleB: "watch.",
        desc: "Music videos, live sessions and visual content for artists and labels: cinematic direction at the service of sound.",
        heroImg: "digital2",
        deliverables: [
          { title: "Music videos", desc: "From concept to post-production: your track's official video with cinematic quality." },
          { title: "Live sessions", desc: "Multi-camera shoots of live performances, with curated audio and dynamic editing." },
          { title: "Lyric & visual videos", desc: "Visual and lyric videos to launch singles and albums on every platform." },
          { title: "Backstage & documentaries", desc: "We tell the making-of and the story behind the music." },
        ],
        gallery: ["editing1", "soundstage", "digital1"],
        spots: VIDEOCLIP_VIDEOS,
        spotsTitle: "The videos",
      },
    },
    contact: {
      kicker: "Contact",
      titleA: "Tell us about",
      titleB: "your project.",
      desc: "Fill in the form: we'll get back to you within 24 working hours with a free first assessment.",
      name: "Full name",
      namePh: "John Smith",
      email: "Email",
      emailPh: "john@company.com",
      company: "Company",
      companyPh: "Company name",
      service: "Service of interest",
      serviceOptions: ["ADV / TV Spots", "Digital & Social", "Corporate", "AI Video", "Other"],
      budget: "Indicative budget",
      budgetOptions: ["< €5,000", "€5,000 – €15,000", "€15,000 – €50,000", "> €50,000"],
      message: "Message",
      messagePh: "Tell us your goals, timeline and what you want the video to achieve…",
      submit: "Send request",
      sending: "Sending…",
      successTitle: "Request sent",
      successDesc: "We'll get back to you within 24 working hours.",
      errorTitle: "Something went wrong",
      errorDesc: "Please try again or email us directly.",
      infoTitle: "Headquarters",
      address: "Via U. Braschi 8, 47822 Santarcangelo di Romagna (RN) · Italy",
      scope: "Video production in Rimini and across Emilia-Romagna · operating nationally and internationally",
      emailLabel: "Email",
      reply: "Guaranteed reply within 24 working hours",
    },
    footer: {
      blurb: "RV FILM is the video production division of Radiovilles: commercials, digital content, corporate and AI video for companies that demand real results. Studio in Santarcangelo di Romagna (Rimini), active across Emilia-Romagna, Italy and abroad.",
      nav: "Navigation",
      contactTitle: "Contact",
      rights: "© 2026 RV FILM · Radiovilles. All rights reserved.",
    },
  },
};
